import { lightBlueColor } from "assets/jss/material-dashboard-pro-react.js";

const cartStyle = (theme) => ({
  containerMenu: {
    width: "100%",
    marginTop: "20px",
    padding: "0 20px",
    [theme.breakpoints.down("md")]: {
      paddingTop: "10px",
    },
  },
  containerDish: {
    fontWeight: "normal",
    display: "inline-block",
    lineHeight: "60px",
  },
  eventText: {
    fontSize: "18px",
    color: "#4a4a4a",
    fontWeight: 900,
    fontFamily: "'Archivo Narrow', sans-serif",
    // font-size: 17px;
    // float: "right",
  },
  dishName: {
    fontSize: "16px",
    color: "#4a4a4a",
    fontFamily: "'Archivo Narrow', sans-serif",
    // font-size: 17px;
    // float: "right",
    lineHeight: "30px",
    margin: 0,
  },
  priceText: {
    fontSize: "17px",
    color: "#4a4a4a",
    fontFamily: "'Archivo Narrow', sans-serif",
    // font-size: 17px;
    fontWeight: "bold",
    textAlign: "right",
    // float: "right",
    lineHeight: "60px",
  },
  buttonSmall: {
    width: "24px",
    height: "24px",
    bordeRadius: "12px",
    border: "solid 1px",
    borderColor: lightBlueColor,
    padding: "0px",
  },
  buttonText: {
    fontSize: "20px",
    color: lightBlueColor,
    lineHeight: "20px",
  },
  buttonBig: {
    width: "100%",
    bordeRadius: "2px",
    height: "40px",
  },
  buttonBigText: {
    fontSize: "15px",
    color: "white",
    lineHeight: "20px",
    fontFamily: "'Archivo Narrow', sans-serif",
  },
  buttonSmallText: {
    fontSize: "13px",
    color: "white",
    lineHeight: "20px",
    fontFamily: "'Archivo Narrow', sans-serif",
  },
  descriptionAdd: {
    fontSize: "14px",
    fontFamily: "'Archivo Narrow', sans-serif",
    color: "#9b9b9b",
  },
  // BY FOODIESTRIP RED
  logo: {
    padding: "15px 0px",
    margin: "0",
    display: "block",
    position: "relative",
    // textAlign: "left",
    textAlign: "center",
    marginBottom: "10px",
    // marginLeft: "20px"
    // zIndex: "1",
    // "&:after": {
    //   content: '""',
    //   position: "absolute",
    //   bottom: "0",
    //   height: "1px",
    //   right: "15px",
    //   width: "calc(100% - 30px)",
    //   backgroundColor: "hsla(0,0%,100%,.3)"
    // }
  },
  img: {
    width: "120px",
    verticalAlign: "middle",
    border: "0",
  },
  emptyCart: {
    fontFamily: "'Archivo Narrow', sans-serif",
    margin: "2px 5px",
    width: "initial",
    textAlign: "center",
    color: "#cbcbcb",
    fontWeight: "bold",
    fontSize: "20px",
    padding: "25px",
    minHeight: "350px",
    [theme.breakpoints.down("md")]: {
      minHeight: "300px",
    },
  },
  minTotal: {
    backgroundColor: "#f0f0f0",
    textAlign: "center",
    padding: "20px",
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
  },
  alertEventContainer: {
    backgroundColor: "#f0f0f0",
    textAlign: "center",
    fontSize: "15px",
    fontFamily: "'Archivo Narrow', sans-serif",
  },
  ticketTextContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export default cartStyle;
